import { Flex } from '@teamsparta/stack-flex';
import { Text } from '@teamsparta/stack-text';
import { vars } from '@teamsparta/stack-tokens';
import Image from 'next/image';
import type { ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  fill?: boolean;
}

export function SubCommentButton({ fill = false, ...props }: Props) {
  return (
    <Flex.Row as='button' align='center' gap={3} aria-label='대댓글' {...props}>
      <Image
        src={
          fill
            ? '/svg/community/speech-bubble-fill.svg'
            : '/svg/community/speech-bubble-line.svg'
        }
        alt='댓글'
        width={16}
        height={16}
      />
      <Text as='span' font='tag2' color={vars.neutral[20]}>
        대댓글
      </Text>
    </Flex.Row>
  );
}
